import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationHistoryContext } from '../App';
import LocalIcon from './LocalIcon';

const Icon = ({ name, className, style }) => (
  <LocalIcon icon={name} className={className} style={style} />
);

const scrollWithOffset = () => {
  const headerOffset = -90;
  const elementPosition = 0;
  const offsetPosition = elementPosition + headerOffset;
  
  window.scrollTo({
    top: offsetPosition,
    behavior: "instant"
  });
};

const BackButton = ({ className }) => {
  const navigate = useNavigate();
  const navigationHistory = useContext(NavigationHistoryContext);

  const handleGoBack = () => {
    const history = navigationHistory.getHistory();
   
    
    if (history.length > 1) {
      // Rimuoviamo la pagina corrente
      history.pop();
      // Prendiamo la pagina precedente
      const previousPage = history[history.length - 1];
      // Aggiorniamo lo storage con la nuova storia
      navigationHistory.updateHistory(history);
      // Navighiamo alla pagina precedente
      navigate(previousPage);
    } else {
      // Fallback a maplist se non abbiamo abbastanza storia
      navigate('/maplist');
    }
    
    // Preveniamo il ripristino dello scroll da parte del browser
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Serie di tentativi di scroll per assicurarci che funzioni
    scrollWithOffset();
    requestAnimationFrame(() => {
      scrollWithOffset();
      setTimeout(scrollWithOffset, 50);
    });
  };

  return (
    <button
      onClick={handleGoBack}
      aria-label="Torna indietro"
      className={`btn bg-white border rounded-circle d-flex align-items-center justify-content-center shadow-sm ratio-1x1 goback ${className}`}
    >
      <Icon name="arrow_back" />
    </button>
  );
};

export default BackButton;